import React, { useEffect } from 'react';
import Timeline from './timeline';
import { Welcome } from './welcome';
import Location from './location';
import Mount from './mount';
import Schedule from './schedule';
import Contact from './contact';
import Confirmation from './confirmation';
import Footer from './footer';
import { connect, useDispatch } from 'react-redux';
import { Switch, Route, useHistory, withRouter, Redirect } from "react-router-dom";
import styles from './css/activation.module.css';
import { showNavigation } from '../store/slices/AppSlice';
function activation(ActivationProps) {
    var pageNumber = 1; //useSelector((state: RootState) => state.activationPage)
    var dispatch = useDispatch();
    var history = useHistory();
    useEffect(function () {
        dispatch(showNavigation(false));
    }, []);
    console.log('activation');
    if (!ActivationProps.serviceEventId) {
        return React.createElement(Redirect, { to: "/" });
    }
    return (React.createElement("div", { className: styles.actcontent },
        React.createElement(Timeline, { currentPage: pageNumber }),
        React.createElement(Switch, null,
            React.createElement(Route, { exact: true, path: "/activation" },
                React.createElement(Welcome, null),
                " :"),
            React.createElement(Route, { path: "/activation/location" },
                React.createElement(Location, null),
                " :"),
            React.createElement(Route, { path: "/activation/mount" },
                React.createElement(Mount, null),
                " :"),
            React.createElement(Route, { path: "/activation/schedule" },
                React.createElement(Schedule, null),
                " :"),
            React.createElement(Route, { path: "/activation/contact" },
                React.createElement(Contact, null),
                " :"),
            React.createElement(Route, { path: "/activation/confirmation" },
                React.createElement(Confirmation, null),
                " :")),
        React.createElement(Footer, null)));
}
function mapStateToProps(state) {
    return {
        serviceEventId: state.serviceEvent.serviceEventId,
        scheduleState: state.serviceEvent.schedule
    };
}
export default withRouter(connect(mapStateToProps)(activation));
